// extracted by mini-css-extract-plugin
export default {"title":"rAsAREps","text":"RHBwtJ6n"};